import { localStore } from '$lib/common';
import { user } from './user';

export const userEmail = localStore('userEmail', "");

user.subscribe((user) => {
    if (user.email) userEmail.set(user.email)
})